import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'

import logob from '../../img/logob.png'
import logo2 from '../../img/logo2.png'
import logo3 from '../../img/logo3.png'

import './index.css'

class Footer extends Component {
  render() {
    return (
      <div>
        <footer>
          <Row className="App-footer">
            <Col xs="12" sm="5">
              <Row>
                <Col sm="5">
                  <img
                    src={logob}
                    className="logo img-fluid"
                    alt="With Watson"
                  />
                </Col>
                <Col sm="4">
                  <img src={logo2} className="logo img-fluid" alt="NAHB" />
                </Col>
                <Col sm="3">
                  <img src={logo3} className="logo img-fluid" alt="ULI" />
                </Col>
              </Row>
            </Col>
            <Col xs="12" sm="7" className="contact">
              <Row>
                <Col xs="12" sm="4" className="phone">
                  Phone: (406) 414.0129
                </Col>
                <Col xs="12" sm="4" className="email">
                  Email: Ask@TobeyApp.com
                </Col>
                <Col xs="12" sm="4" className="name">
                  Made in Bozeman, Montana &copy;2017
                </Col>
              </Row>
            </Col>
          </Row>
        </footer>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js